import styled from 'styled-components';

export const Text = styled.span`
  margin-right: 0.6rem;
`;



// WEBPACK FOOTER //
// ./containers/HomePage/OpeningTimes.style.js